import TyRoomList from './TyRoomList.vue'
export default TyRoomList



// WEBPACK FOOTER //
// ./src/components/ty-room-list/index.js